import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=4ffcb2a8&scoped=true&"
import script from "./Announcements.vue?vue&type=script&lang=js&"
export * from "./Announcements.vue?vue&type=script&lang=js&"
import style1 from "./Announcements.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffcb2a8",
  null
  
)

export default component.exports